/**
 * Abstract service.
 *
 * @abstract
 */
export default class HttpCacheAbstractService {
  /**
   * Constructor.
   *
   * @param {String} serviceType
   */
  constructor(serviceType) {
    this.serviceType = serviceType
    this.partialResult = false
  }

  /**
   * Does this service support the given cache pool?
   *
   * @param {HttpCachePoolConfig} poolConfig
   * @return {boolean}
   */
  supports(poolConfig) {
    return poolConfig.service === this.serviceType
  }

  /**
   * Reads the cache pool for matches for the current request.
   *
   * @param {String} path
   * @param {Object} parameters
   * @param {HttpCachePoolConfig} poolConfig
   * @param {Array<HttpCacheItem>} cachePool
   * @return {HttpCacheItem|Array<HttpCacheItem>|null}
   */
  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  read({ path, parameters, poolConfig }, cachePool) {
    throw new Error('Abstract method called')
  }

  /**
   * Writes to the cache pool.
   *
   * @param {String} path
   * @param {Object} parameters
   * @param {HttpCachePoolConfig} poolConfig
   * @param {string} currentTimestamp
   * @param {Array<HttpCacheItem>} cachePool
   * @param {*} valueOrValues
   * @return {Array<HttpCacheItem>}
   */
  // eslint-disable-next-line no-unused-vars,class-methods-use-this
  write({ path, parameters, poolConfig, currentTimestamp }, cachePool, valueOrValues) {
    throw new Error('Abstract method called')
  }

  /**
   * Return the partial result flag.
   * A partial result indicates that the request may still need to be executed.
   *
   * @return {boolean}
   */
  isPartialResult() {
    return this.partialResult
  }
}
